/* tslint:disable */
/* eslint-disable */
/**
 * ${api_name}
 * The Ciptex Race Notified Booking API is for use from [Ciptex Race](https://ciptex.com/race), [Twilio Flex](https://www.twilio.com/flex) and [Twilio Studio](https://www.twilio.com/studio)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ConferenceFromJSON, ConferenceDetailToJSON, ListConferenceFromJSON, } from '../models/index';
/**
 *
 */
export class ConferenceApi extends runtime.BaseAPI {
    /**
     * Remove Conference
     * Remove Conference
     */
    bookingBookingIdConferenceConferenceIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['bookingId'] == null) {
                throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling bookingBookingIdConferenceConferenceIdDelete().');
            }
            if (requestParameters['conferenceId'] == null) {
                throw new runtime.RequiredError('conferenceId', 'Required parameter "conferenceId" was null or undefined when calling bookingBookingIdConferenceConferenceIdDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/booking/{BookingId}/conference/{ConferenceId}`.replace(`{${"BookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))).replace(`{${"ConferenceId"}}`, encodeURIComponent(String(requestParameters['conferenceId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Remove Conference
     * Remove Conference
     */
    bookingBookingIdConferenceConferenceIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.bookingBookingIdConferenceConferenceIdDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Fetch Conference
     * Fetch Conference
     */
    bookingBookingIdConferenceConferenceIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['bookingId'] == null) {
                throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling bookingBookingIdConferenceConferenceIdGet().');
            }
            if (requestParameters['conferenceId'] == null) {
                throw new runtime.RequiredError('conferenceId', 'Required parameter "conferenceId" was null or undefined when calling bookingBookingIdConferenceConferenceIdGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/booking/{BookingId}/conference/{ConferenceId}`.replace(`{${"BookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))).replace(`{${"ConferenceId"}}`, encodeURIComponent(String(requestParameters['conferenceId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ConferenceFromJSON(jsonValue));
        });
    }
    /**
     * Fetch Conference
     * Fetch Conference
     */
    bookingBookingIdConferenceConferenceIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.bookingBookingIdConferenceConferenceIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update Conference
     * Update Conference
     */
    bookingBookingIdConferenceConferenceIdPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['bookingId'] == null) {
                throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling bookingBookingIdConferenceConferenceIdPatch().');
            }
            if (requestParameters['conferenceId'] == null) {
                throw new runtime.RequiredError('conferenceId', 'Required parameter "conferenceId" was null or undefined when calling bookingBookingIdConferenceConferenceIdPatch().');
            }
            if (requestParameters['conferenceDetail'] == null) {
                throw new runtime.RequiredError('conferenceDetail', 'Required parameter "conferenceDetail" was null or undefined when calling bookingBookingIdConferenceConferenceIdPatch().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/booking/{BookingId}/conference/{ConferenceId}`.replace(`{${"BookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))).replace(`{${"ConferenceId"}}`, encodeURIComponent(String(requestParameters['conferenceId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: ConferenceDetailToJSON(requestParameters['conferenceDetail']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ConferenceFromJSON(jsonValue));
        });
    }
    /**
     * Update Conference
     * Update Conference
     */
    bookingBookingIdConferenceConferenceIdPatch(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.bookingBookingIdConferenceConferenceIdPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * List Conference
     * List Conference
     */
    bookingBookingIdConferenceGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['bookingId'] == null) {
                throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling bookingBookingIdConferenceGet().');
            }
            const queryParameters = {};
            if (requestParameters['startDateFrom'] != null) {
                queryParameters['startDateFrom'] = requestParameters['startDateFrom'].toISOString();
            }
            if (requestParameters['startDateTo'] != null) {
                queryParameters['startDateTo'] = requestParameters['startDateTo'].toISOString();
            }
            if (requestParameters['hostId'] != null) {
                queryParameters['hostId'] = requestParameters['hostId'];
            }
            if (requestParameters['status'] != null) {
                queryParameters['status'] = requestParameters['status'];
            }
            if (requestParameters['conferenceType'] != null) {
                queryParameters['conferenceType'] = requestParameters['conferenceType'];
            }
            if (requestParameters['search'] != null) {
                queryParameters['search'] = requestParameters['search'];
            }
            if (requestParameters['pageSize'] != null) {
                queryParameters['pageSize'] = requestParameters['pageSize'];
            }
            if (requestParameters['lastKey'] != null) {
                queryParameters['lastKey'] = requestParameters['lastKey'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/booking/{BookingId}/conference`.replace(`{${"BookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ListConferenceFromJSON(jsonValue));
        });
    }
    /**
     * List Conference
     * List Conference
     */
    bookingBookingIdConferenceGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.bookingBookingIdConferenceGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create Conference
     * Create Conference
     */
    bookingBookingIdConferencePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['bookingId'] == null) {
                throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling bookingBookingIdConferencePost().');
            }
            if (requestParameters['conferenceDetail'] == null) {
                throw new runtime.RequiredError('conferenceDetail', 'Required parameter "conferenceDetail" was null or undefined when calling bookingBookingIdConferencePost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/booking/{BookingId}/conference`.replace(`{${"BookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ConferenceDetailToJSON(requestParameters['conferenceDetail']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ConferenceFromJSON(jsonValue));
        });
    }
    /**
     * Create Conference
     * Create Conference
     */
    bookingBookingIdConferencePost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.bookingBookingIdConferencePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Fetch Conference
     * Fetch Conference
     */
    conferenceConferenceIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['conferenceId'] == null) {
                throw new runtime.RequiredError('conferenceId', 'Required parameter "conferenceId" was null or undefined when calling conferenceConferenceIdGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/conference/{ConferenceId}`.replace(`{${"ConferenceId"}}`, encodeURIComponent(String(requestParameters['conferenceId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ConferenceFromJSON(jsonValue));
        });
    }
    /**
     * Fetch Conference
     * Fetch Conference
     */
    conferenceConferenceIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.conferenceConferenceIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * List Conference
     * List Conference
     */
    conferenceGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['startDateFrom'] != null) {
                queryParameters['startDateFrom'] = requestParameters['startDateFrom'].toISOString();
            }
            if (requestParameters['startDateTo'] != null) {
                queryParameters['startDateTo'] = requestParameters['startDateTo'].toISOString();
            }
            if (requestParameters['hostId'] != null) {
                queryParameters['hostId'] = requestParameters['hostId'];
            }
            if (requestParameters['status'] != null) {
                queryParameters['status'] = requestParameters['status'];
            }
            if (requestParameters['conferenceType'] != null) {
                queryParameters['conferenceType'] = requestParameters['conferenceType'];
            }
            if (requestParameters['search'] != null) {
                queryParameters['search'] = requestParameters['search'];
            }
            if (requestParameters['pageSize'] != null) {
                queryParameters['pageSize'] = requestParameters['pageSize'];
            }
            if (requestParameters['lastKey'] != null) {
                queryParameters['lastKey'] = requestParameters['lastKey'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/conference`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ListConferenceFromJSON(jsonValue));
        });
    }
    /**
     * List Conference
     * List Conference
     */
    conferenceGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.conferenceGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
